<div class="row p-2">
    <div class="col-lg-12">
        <ul class="list-unstyled">
            <li *ngFor="let ad of data?.appOverview?.appAdvisories">
                <i class="fa fa-minus" aria-hidden="true"></i> {{ad}}
            </li>
        </ul>
    </div>
</div>